import React from 'react';

import { Container, FrameContainer } from './style';
import { LoadingComponent } from 'components/Loading';

interface IFrameData {
  children?: React.ReactNode;
  loading?: boolean;
  centerContent?: boolean;
}

export const FrameData = ({ children, loading, centerContent = true }: IFrameData) => {
  return (
    <Container centerContent={centerContent} className="sidemodal">
      {loading && <LoadingComponent absolute borderRadius={26} background="#f5f5f5" size={80} color="#74C598" />}
      <FrameContainer>{children}</FrameContainer>
    </Container>
  );
};
